/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VerticalStructureEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const VerticalStructureEnum = {
    NUMBER_1: 1 as VerticalStructureEnum,
    NUMBER_2: 2 as VerticalStructureEnum,
    NUMBER_3: 3 as VerticalStructureEnum,
    NUMBER_4: 4 as VerticalStructureEnum,
    NUMBER_5: 5 as VerticalStructureEnum,
    NUMBER_6: 6 as VerticalStructureEnum,
    NUMBER_7: 7 as VerticalStructureEnum,
    NUMBER_8: 8 as VerticalStructureEnum
};

